/**
 * 时间戳转换时间
 * param {Number} type: day-代表截止显示年-月-日  time-代表显示时-分-秒
 */
const formatTime = (date, type) => {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()

  if (type) {
    if (type === 'day') {
      return [year, month, day].map(formatNumber).join('-')
    } else if (type === 'time') {
      return [hour, minute].map(formatNumber).join(':')
    } else if (type === 'daytime') {
      return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute].map(formatNumber).join(':')
    } else if (type === 'standardTime') {
      return year + '年' + month + '月' + day + '日'
    } else if (type === 'days') {
      return [year, month, day].map(formatNumber).join('/')
    }
  } else {
    return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
  }
}

const formatNumber = n => {
  n = n.toString()
  return n[1] ? n : '0' + n
}

const initOverTime = (effectTime) => {
  // 获得当前系统的时间
  let currentDate = new Date()
  let res = false
  let currentTime = currentDate.getTime()
  if (effectTime < currentTime) {
    res = true
  }
  return res
}
export default {
  formatTime: formatTime,
  initOverTime: initOverTime
}
